import React from 'react';

class CallUs1 extends React.Component {
    render() {
        return (
            <>
                <div className="section-full p-t80 p-b50 bg-gray-light">
                    <div className="container">
                        {/* TITLE START*/}
                        <div className="section-head center wt-small-separator-outer text-center">
                            <div className="wt-small-separator site-text-primary">
                                <div className="sep-leaf-left" />
                                <div>Call Us And get it done!</div>
                                <div className="sep-leaf-right" />
                            </div>
                            <h2>We Have 30+ Years Industrial Experiences</h2>
                        </div>
                        {/* TITLE END*/}
                        <div className="section-content">
                            <div className="icon-circle-box-outer bg-white p-a30 m-b30">
                                <div className="row justify-content-center ">
                                    <div className="col-lg-4 col-md-6 col-sm-12 ">
                                        <div className="icon-circle-box v-icon-effect">
                                            <div className="wt-icon-box-wraper center">
                                                <div className="icon-md icon-circle">
                                                    <span className="icon-cell">
                                                        <i className="flaticon-call v-icon " />
                                                    </span>
                                                </div>
                                                <div className="icon-content relative">
                                                    <h4 className="wt-tilte">Have a question? call us now</h4>
                                                    <span className="icon-count-number">1</span>
                                                    <p>+(06) 0205 783 5586</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-6 col-sm-12">
                                        <div className="icon-circle-box v-icon-effect">
                                            <div className="wt-icon-box-wraper center">
                                                <div className="icon-md icon-circle">
                                                    <span className="icon-cell">
                                                        <i className="flaticon-mail v-icon " />
                                                    </span>
                                                </div>
                                                <div className="icon-content relative">
                                                    <h4 className="wt-tilte">Need support? Drop us an Email</h4>
                                                    <span className="icon-count-number">2</span>
                                                    <p>info@thewebmax.com</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-6 col-sm-12">
                                        <div className="icon-circle-box  v-icon-effect">
                                            <div className="wt-icon-box-wraper center">
                                                <div className="icon-md icon-circle">
                                                    <span className="icon-cell">
                                                        <i className="flaticon-history v-icon " />
                                                    </span>
                                                </div>
                                                <div className="icon-content relative">
                                                    <h4 className="wt-tilte">We are open on</h4>
                                                    <span className="icon-count-number">3</span>
                                                    <p><span>Mon - Sat  07:00 - 21:00</span><span>Sunday - Closed</span></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default CallUs1;